import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";

export type StatsTab = "global" | "parcours" | "apprenants" | "classement" | "comparateur";

interface StatsTabsProps {
  activeTab?: StatsTab;
  onChange?: (tab: StatsTab) => void;
}

const StatsTabs = ({ activeTab, onChange }: StatsTabsProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const tabs: { key: StatsTab; label: string; path: string }[] = [
    {
      key: "global",
      label: t("statsNew.tabs.global"),
      path: "/statistics",
    },
    {
      key: "parcours",
      label: t("statsNew.tabs.parcours"),
      path: "/statistics/parcours",
    },
    {
      key: "apprenants",
      label: t("statsNew.tabs.apprenants"),
      path: "/statistics/apprenants",
    },
    {
      key: "classement",
      label: t("statsNew.tabs.classement"),
      path: "/statistics/classement",
    },
    {
      key: "comparateur",
      label: t("statsNew.tabs.comparateur"),
      path: "/statistics/comparateur",
    },
  ];

  const getIsActive = (path: string, key: StatsTab): boolean => {
    const pathname = location.pathname;

    // For global tab, only match exact path (not sub-paths)
    if (key === "global") {
      return pathname === "/statistics" || pathname === "/statistics/";
    }

    // For other tabs, match if pathname starts with the tab's path
    return pathname.startsWith(path);
  };

  return (
    <div className="flex border-b border-gray-200">
      {tabs.map((tab) => {
        const isActive = activeTab ? activeTab === tab.key : getIsActive(tab.path, tab.key);

        if (onChange) {
          return (
            <button
              key={tab.key}
              onClick={() => onChange(tab.key)}
              className={`px-6 py-3 text-sm font-medium transition-colors relative ${
                isActive ? "text-green-600" : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {tab.label}
              {isActive && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-green-600" />}
            </button>
          );
        }

        return (
          <NavLink
            key={tab.key}
            to={tab.path}
            className={`px-6 py-3 text-sm font-medium transition-colors relative ${
              isActive ? "text-green-600" : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab.label}
            {isActive && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-green-600" />}
          </NavLink>
        );
      })}
    </div>
  );
};

export default StatsTabs;
